import script from "./JoinFlight.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinFlight.vue?vue&type=script&setup=true&lang=js"

import "./JoinFlight.vue?vue&type=style&index=0&id=6201d5de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6201d5de"]])

export default __exports__